import { createAction } from 'typesafe-actions';
import { SettingsActionTypes, SettingsState } from './types';

// eslint-disable-next-line import/prefer-default-export
export const updateSettings = createAction(SettingsActionTypes.UPDATE_SETTINGS)<SettingsState>();
